import React, { useState } from 'react';
import { CONVERSATION_DRAG_TYPE } from '../types';

interface ProjectDropTargetProps {
  onDropConversation: (sessionId: string) => void;
  className?: string;
  /** Extra classes while a conversation is dragged over the target. */
  activeClassName?: string;
  children: React.ReactNode;
}

const hasConversation = (event: React.DragEvent) =>
  event.dataTransfer.types.includes(CONVERSATION_DRAG_TYPE);

/** Native HTML5 drop zone that accepts a dragged conversation. */
export const ProjectDropTarget: React.FC<ProjectDropTargetProps> = ({
  onDropConversation,
  className = '',
  activeClassName = 'ring-2 ring-blue-500 bg-blue-50 dark:bg-blue-500/10',
  children,
}) => {
  const [isOver, setIsOver] = useState(false);

  const handleDragOver = (event: React.DragEvent) => {
    if (!hasConversation(event)) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    setIsOver(true);
  };

  const handleDrop = (event: React.DragEvent) => {
    if (!hasConversation(event)) return;
    event.preventDefault();
    setIsOver(false);
    const sessionId = event.dataTransfer.getData(CONVERSATION_DRAG_TYPE);
    if (sessionId) onDropConversation(sessionId);
  };

  return (
    <div
      className={`${className} ${isOver ? activeClassName : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={() => setIsOver(false)}
      onDrop={handleDrop}
    >
      {children}
    </div>
  );
};
